const ServiceFeatures = () => {
  const features = [
    {
      icon: 'ri-building-line',
      title: 'Retaining Walls',
      description: 'Structural and decorative retaining walls that prevent erosion while enhancing your landscape design.'
    },
    {
      icon: 'ri-road-map-line',
      title: 'Patios & Walkways',
      description: 'Custom stone patios and walkways that create beautiful, functional outdoor living spaces.'
    },
    {
      icon: 'ri-plant-line',
      title: 'Decorative Landscaping',
      description: 'Natural stone accents and features that add character and elegance to your property.'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Natural Stone Veneer',
      description: 'Premium stone veneer installation for exterior walls, fireplaces, and architectural features.'
    },
    {
      icon: 'ri-stairs-line',
      title: 'Stone Steps',
      description: 'Durable and attractive stone steps designed for safety, accessibility, and aesthetic appeal.'
    },
    {
      icon: 'ri-pencil-ruler-2-line',
      title: 'Custom Design',
      description: 'Personalized stone solutions tailored to your vision, property layout, and functional needs.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-6">
            What We Offer
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive stone services for residential and commercial properties. 
            Quality materials, expert installation, and designs built to last.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-all cursor-pointer"
            >
              <div className="w-16 h-16 bg-yellow-500 rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-black`}></i>
              </div>
              <h3 className="text-2xl font-bold text-black mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceFeatures;